import React from 'react';
import { Crown } from 'lucide-react';

export function PremiumBadge({ size = 'md', showLabel = true }) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-xs',
    lg: 'text-sm',
  };

  if (!showLabel) {
    return (
      <div className="inline-flex items-center justify-center w-6 h-6 bg-amber-100 text-amber-700 rounded-full">
        <Crown className={sizeClasses[size]} fill="currentColor" />
      </div>
    );
  }

  return (
    <div className="inline-flex items-center gap-1.5 px-2 py-1 bg-gradient-to-r from-amber-50 to-amber-100 border border-amber-200">
      <Crown className={sizeClasses[size]} fill="currentColor" strokeWidth={0} />
      <span className={`${textSizeClasses[size]} uppercase tracking-widest text-amber-900`}>
        Premium
      </span>
    </div>
  );
}

